<mat-toolbar class="main-toolbar" color="primary">
  <a class="toolbar-site-logo" [routerLink]="['/', pagesPATH.CUSTOMERS]">
    <img [src]="publicApi.mrcLogoWhite" />
  </a>
  <span class="toolbar-spacer"></span>
  <ng-container>
    <app-state-chips-component
      [user]="stateService.user$ | async"
      [customer_organizations]="organizations"
      [sales_organizations]="salesOrganizations"
      [sales_org]="stateService.sales_organization$ | async"
      [customer_org]="stateService.customer_organization$ | async"
    ></app-state-chips-component>
  </ng-container>
</mat-toolbar>
